export const routes = {
    "/employeeSatisfactionSurvey/:customerId/:taskId": {
        title: "Satisfaction Survey",
        authorize: false
    }
};
